<template>
  <div class="profile-container">
    <h2 class="profile-title">{{ userName }}</h2>
    
    <div class="data-section">
      <div class="button-group">
        <DxButton 
        @click="openDataFolder" 
        text="Open Data Folder"
        class="action-button"
        />
        <DxButton 
          @click="exportData" 
          text="Export all data"
          class="action-button"
        />
      </div>
    </div>
  </div>
</template>

<script setup>

import DxButton from "devextreme-vue/button";

import { useStore } from 'vuex';
import { computed } from 'vue';

const store = useStore();

// Get user information from store
const user = computed(() => store.getters.getUser);
const userName = computed(() => {
  if (user.value?.name) {
    return user.value.name;
  } else if (user.value?.email) {
    // Extract name from email (part before @)
    return user.value.email.split('@')[0];
  }
  return 'Profile';
});

function exportData() {
  store.dispatch('getAllData')
}

function openDataFolder() {
  // TODO: Implement this function to open the data folder
  store.dispatch('openStore')
}

</script>

<style lang="scss">
.profile-container {
  max-width: 600px;
  padding: 2rem;
}

.profile-title {
  font-size: 1.8rem;
  font-weight: 500;
  color: #333;
  margin-bottom: 2rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #e5e5e5;
}

.data-section {
  background: #fafafa;
  padding: 1.5rem;
  border-radius: 6px;
  border: 1px solid #e5e5e5;
}

.button-group {
  display: flex;
  gap: 0.75rem;
  flex-wrap: wrap;
}

.action-button {
  min-width: 140px;
  padding: 8px 16px;
}

// Responsive design
@media (max-width: 768px) {
  .profile-container {
    margin: 1rem;
    padding: 1rem;
  }
  
  .button-group {
    flex-direction: column;
  }
  
  .action-button {
    min-width: 100%;
  }
}

// Legacy styles (keeping for compatibility)
.form-avatar {
  float: left;
  height: 120px;
  width: 120px;
  margin-right: 20px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  background-color: #fff;
  overflow: hidden;

  img {
    height: 120px;
    display: block;
    margin: 0 auto;
  }
}
</style>
